import * as exElement from '../element';

import arrayBufferToUrl from './arrayBufferToUrl';

// ----------------------------------------------------------------------------

async function arrayBufferToVideo(arrayBuffer: ArrayBuffer, config: Record<string, any> = {}): Promise<any> {
    // New Promise
    const promise = new Promise(function (resolve, reject): any {
        // ArrayBuffer To Url
        const url = arrayBufferToUrl(arrayBuffer);
        const urlCreator = window.URL || window.webkitURL;

        // Create element (video)
        const elVideo = exElement.create({
            merge: config,
            tag: 'video',
        }) as HTMLVideoElement;

        // Create event (loaded meta data)
        elVideo.addEventListener('loadedmetadata', function (evt: Event): any {
            this.currentTime = 0;
            resolve(evt.target);
        });
        // Create event (ended)
        /*
         * elVideo.addEventListener('ended', function () {
         *  urlCreator.revokeObjectURL(url);
         * });
         */
        // Create event (error)
        elVideo.addEventListener('error', function (err): any {
            urlCreator.revokeObjectURL(url);
            reject(err);
        });

        // Set source
        elVideo.src = url;
    });

    // Return
    return promise;
}

// ----------------------------------------------------------------------------

export default arrayBufferToVideo;
